
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import isArray from 'lodash/isArray';

const Toolbar = (props) => {

    const classNames = mergeStyleSets({
        root: {
        }
    });

    const horizontal = ((props.position === 'top') || (props.position === 'bottom'));

    const buttons = props.buttons || [];

    const getButtons = (buttonsDefinition) => {
        let buttons = [];
        buttonsDefinition.forEach(item => {
            if (isArray(item)) {
                item.forEach(item2 => buttons.push(item2));
            } else {
                buttons.push(item);
            }
        })
        return buttons;
    }

    return (
        <Stack horizontal={horizontal} className={classNames.root}>
            {getButtons(buttons).map((item, index) => {
                return (
                    <React.Fragment key={index}>
                        {item}
                    </React.Fragment>
                );
            })}
        </Stack>
    )
}

export default Toolbar;
